import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useCloseInquiry from './hooks/useCloseInquiry';

interface Params {
    inquiryId: string;
}

const CloseInquiryModal:ActivityComponentType<Params> = ({ params }: {params: Params}) => {
    const { t } = useTranslation('inquiry');
    const { inquiryId } = params;
    const { pop } = useFlow();
    const closeInquiry = useCloseInquiry(inquiryId);
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={42} align='center'>
                    <Column spacing={8} align='center'>
                        <Text fontWeight='bold' size='2xl'>
                            {t('closeModal.title')}
                        </Text>
                        <Text color={colors.gray6}>
                            {t('closeModal.description')}
                        </Text>
                    </Column>
                    <Row fullWidth spacing={10}>
                        <Button fullWidth onClick={pop} variant='secondary' noPadding>
                            {t('closeModal.cancel')}
                        </Button>
                        <Button fullWidth onClick={closeInquiry} noPadding>
                            {t('closeModal.confirm')}
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default CloseInquiryModal;
